import { cx } from '@vizit/theme';
import * as React from 'react';
import { TextArea, type TextAreaProps } from 'react-aria-components';
import { inputClasses } from '../input/styles';

interface _TextAreaProps extends TextAreaProps {}

/**
 * The TextArea component is used to create a multi-line text input field.
 * Like Input, it is intentionally unstyled beyond typography and placeholder
 * colors so consumers can wrap it in their own field container.
 *
 * @param props - The props for the TextArea component.
 * @example
 * <TextArea placeholder="Add a description" />
 */
const _TextArea = React.forwardRef((props: TextAreaProps, ref: React.Ref<HTMLTextAreaElement>) => {
  const { className, ...other } = props;

  return <TextArea ref={ref} className={inputClasses({ className: cx('resize-none', className) })} {...other} />;
});

export { _TextArea as TextArea };
export type { _TextAreaProps as TextAreaProps };
